import { uuidPattern, machineNamePattern } from "@/lib/raft_generic_helper";

const MyJobsListing = () => import("@/components/user_job/MyJobsListing.vue");
const UserJobView = () => import("@/components/user_job/UserJobView.vue");

const routes = [
  {
    path: "/user/:userUid([0-9]+)/view/jobs",
    component: MyJobsListing,
    props: true,
    name: "MyJobsListing",
  },
  {
    path:
      "/user/:userUid([0-9]+)/view/jobs/:bundle(" +
      machineNamePattern +
      ")/:uuid(" +
      uuidPattern +
      ")",
    component: UserJobView,
    props: true,
  },
];

export default routes;
